var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5C22.875 2.5 29 8.5625 29 16C29 23.5 22.9375 29.5 15.5 29.5C8 29.5 2 23.5 2 16C2 8.5625 8 2.5 15.5 2.5ZM15.5 0.5C6.9375 0.5 0 7.5 0 16C0 24.5625 6.9375 31.5 15.5 31.5C24 31.5 31 24.5625 31 16C31 7.5 24 0.5 15.5 0.5ZM13.25 22C12.8125 22 12.5 22.375 12.5 22.75V23.25C12.5 23.6875 12.8125 24 13.25 24H17.75C18.125 24 18.5 23.6875 18.5 23.25V22.75C18.5 22.375 18.125 22 17.75 22H17V13.25C17 12.875 16.625 12.5 16.25 12.5H13.25C12.8125 12.5 12.5 12.875 12.5 13.25V13.75C12.5 14.1875 12.8125 14.5 13.25 14.5H14V22H13.25ZM15.5 7C14.375 7 13.5 7.9375 13.5 9C13.5 10.125 14.375 11 15.5 11C16.5625 11 17.5 10.125 17.5 9C17.5 7.9375 16.5625 7 15.5 7Z",
    fill: "#605FF3"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.a216e9b3.svg";
export { ForwardRef as ReactComponent };